<?xml version="1.0" encoding="iso-8859-1"?>
<svg fill="#FFFFFF" version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" 
	 viewBox="0 0 456.548 456.548" xml:space="preserve">
<g id="XMLID_809_">
	<g>
		<g>
			<path d="M433.467,81.51H23.081C10.334,81.51,0,91.844,0,104.591v26.274h456.548v-26.274
				C456.548,91.844,446.214,81.51,433.467,81.51z"/>
			<path d="M0,351.957c0,12.747,10.334,23.081,23.081,23.081h410.385c12.747,0,23.081-10.334,23.081-23.081V198.355H0V351.957z
				 M196.171,323.51h-29c-8.284,0-15-6.716-15-15s6.716-15,15-15h29c8.284,0,15,6.716,15,15S204.455,323.51,196.171,323.51z
				 M348.467,293.51h47c8.284,0,15,6.716,15,15s-6.716,15-15,15h-47c-8.284,0-15-6.716-15-15S340.183,293.51,348.467,293.51z
				 M303.171,308.51c0,8.284-6.716,15-15,15h-29c-8.284,0-15-6.716-15-15s6.716-15,15-15h29
				C296.455,293.51,303.171,300.226,303.171,308.51z M58.874,236.51h224c8.284,0,15,6.716,15,15s-6.716,15-15,15h-224
				c-8.284,0-15-6.716-15-15S50.59,236.51,58.874,236.51z M58.874,293.51h47c8.284,0,15,6.716,15,15s-6.715,15-15,15h-47
				c-8.284,0-15-6.716-15-15S50.59,293.51,58.874,293.51z"/>
		</g>
	</g>
</g>
</svg>